export default {"src":"/_next/static/media/info.9b86e156.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};